import {
  CreateChecklistDefinitionRequestBody,
  UpdateChecklistDefinitionRequestBody,
} from '@dms/api/core';

import {ChecklistFormValue} from '../types/ChecklistFormValue';

const toCommonShape = (formData: ChecklistFormValue) => ({
  resourceId: formData.resourceId,
  name: formData.name,
  description: formData.description ?? null,
});

export const toCreateChecklistDefinitionBody = (
  formData: ChecklistFormValue
): CreateChecklistDefinitionRequestBody => ({
  ...toCommonShape(formData),
  tasks: formData.tasks.map((task) => ({
    description: task.description,
    isMandatory: task.isMandatory,
    fileRequired: task.fileRequired,
  })),
});

export const toUpdateChecklistDefinitionBody = (
  formData: ChecklistFormValue
): UpdateChecklistDefinitionRequestBody => ({
  ...toCommonShape(formData),
  tasks: formData.tasks.map((task) => ({
    id: task.id ?? null,
    description: task.description,
    isMandatory: task.isMandatory,
    fileRequired: task.fileRequired,
  })),
});
